import { SCHEMA_VERSION } from '@oneappexchange/oaf-schema';
import { LISTING_SERVICE_API_VERSION, LISTING_SERVICE_URL } from '~/modules/config';
import { getListingResponse, ListingResponse } from '~/modules/services/listing_service';
import { handleException } from '~/modules/utilities/error_utilities';
import { http, HttpRequestConfig } from '~/modules/utilities/http';
import { Marketplace } from '~/modules/utilities/language_utils';

// @ts-expect-error * Automated Type Error Fix
const parseResponse = (response) => {
    // @ts-expect-error * Automated Type Error Fix
    return response.map((listing) => {
        return getListingResponse(listing);
    });
};
const config: HttpRequestConfig = {
    headers: {
        Version: LISTING_SERVICE_API_VERSION || '1',
        SchemaVersion: SCHEMA_VERSION,
    },
    transformResponse: [
        (data) => {
            return data ? JSON.parse(data) : undefined;
        },
        (data) => {
            return data ? parseResponse(data) : undefined;
        },
    ],
};

const PARAM_LISTING_ID = 'listingId';
const PARAM_MARKETPLACE = 'marketplace';
const PARAM_PUBLISHER_ID = 'publisherId';

export async function getPublisherListings(
    publisherId: string,
    listingId: string,
    marketplace: Marketplace = 'English',
): Promise<ListingResponse[]> {
    const url = `${LISTING_SERVICE_URL}?${PARAM_PUBLISHER_ID}=${publisherId}&${PARAM_LISTING_ID}=${listingId}&${PARAM_MARKETPLACE}=${marketplace}`;
    try {
        return http.get(url, config).then((response) => response?.data);
    } catch (error) {
        handleException(error, 'moreFromProviderService.getPublisherListings', { url });
        throw error;
    }
}
